import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { of } from 'rxjs';
import { FormValidators } from 'src/app/@forms/validators/validators';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService, POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { ADDRESS, ASK_FOR_POI, CANCEL, CLOSE, FILL_DETAILS_FOR_POI, MANDATORY_FIELD, POI_NAME, SEND } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { LocationService } from 'src/app/modules/route-planner/services/location/location.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

export interface POIRequest {
  name: string;
  address: string;
}

@Component({
    selector: 'app-request-poi',
    templateUrl: './request-poi.component.html',
    styleUrls: ['./request-poi.component.scss'],
    standalone: false
})
export class RequestPoiComponent extends CardDesignComponent implements OnInit {
  poiForm: FormGroup;

  askPoiText: string
  fillDetailsText: string
  addressText: string
  poiNameText: string
  mandatoryFieldText: string
  sendText: string
  cancelText: string
  closeText: string

  direction: Direction

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    private readonly locationService: LocationService,
    private readonly languageService: LanguageService,
    private readonly modalService: ModalService,
    @Inject(POPUP_DATA)
    public readonly data: {
      poiName: string;
    },
    private readonly fb: FormBuilder
  ) {
    super(routePlanningService, resizeService, overlay);

    this.poiForm = fb.group({
      name: new FormControl<string>(data?.poiName, FormValidators.required),
      address: new FormControl<string>(null, FormValidators.required),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.askPoiText = ASK_FOR_POI[language.language]
      this.fillDetailsText = FILL_DETAILS_FOR_POI[language.language]
      this.addressText = ADDRESS[language.language]
      this.poiNameText = POI_NAME[language.language]
      this.mandatoryFieldText = MANDATORY_FIELD[language.language]
      this.sendText = SEND[language.language]
      this.cancelText = CANCEL[language.language]
      this.closeText = CLOSE[language.language]
    })
  }

  sendPOI() {
    if (!!this.poiForm.valid && !!this.poiForm.dirty) {
      const request: POIRequest = this.poiForm.value;
      this.locationService.sendPointOfInterest(request).subscribe({
        next: () => {
          this.modalService.openRequestSentPopUp()
          this.closeCard()
        },
        error: () => {
          this.modalService.openErrorModal("")
          this.closeCard()
        }
      })
      // TODO: Complete request to server
      // of(true).subscribe(() => this.closeCard());
    }
  }
}
